<template>
    <div class="d-flex row p-2 w-100">
        <input
            class="form-control form-control-sm"
            type="search"
            id="search_markers"
            name="search"
            v-model="form.search"
            placeholder="Search Markers"
            aria-label="Search Markers"
            @blur="fetchSearch"
            @input="fetchSearch"
        >
        <div class="row mt-4 p-4 mx-auto scroll-window">
            <div class="d-flex align-items-center mb-1 p-2 border rounded justify-content-between" v-for="result in results" :key="result.id">
                <div class="d-flex align-items-center">
                    <img :src="result?.url" alt="" class="img me-4" width="32">
                    {{ result?.label }}
                </div>
                <button @click="add(result)" class="btn btn-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import throttle from 'lodash/throttle'

export default {
    props: ['element', 'listener'],
    emits: ['updated:results', 'select', 'canceled'],
    data() {
        return {
            newResults: {
                icons: [],
                groups: [],
            },
            form: {
                search: null,
            },
            results: [],
            error: false,
            selected: null
        };
    },
    methods: {
        add(selected) {
            document.dispatchEvent(new CustomEvent(this.listener, {
                detail: {
                    selected
                }
            }))

            this.$emit('select', selected);
        },
        search() {
            this.clear()

            if (this.form.search == "") {
                return
            }

            this.newResults = [];

            this.fetchSearch()
        },
        fetchSearch: throttle(function () {
            axios.get(`/markers/search?query=${this.form.search}&withCollection=false`)
                .then(response => {
                    if (response.status == 200) {
                        this.results = response.data.data?.markers?.flat() ?? []
                    }
                    this.$emit('update:results', this.results)
                })
                .catch(error => {
                    console.error(error)
                    this.$emit('update:results', this.results)
                })
        }, 500, { trailing: true }),
        clear() {
            this.results = []
            this.$emit('update:results', this.newResults);
        }
    },
}
</script>

<style lang="css" scoped>
    .scroll-window {
        max-height: 300px;
        overflow: scroll;
    }
</style>
